import axios, { AxiosResponse } from "axios";
import { WebAPI, IFailCallbackParam } from "../constants";
import { getErrorStatus } from "./getErrorStatus";
import AuthService from "../../common/AuthService";

interface ICallbackParams extends IFailCallbackParam {
  /**
   * WebAPIでライセンスコードの登録が成功した場合に呼び出されます
   * @callback success
   * @param {number} status - httpステータス
   */
  success: (status: number) => void;
}

export interface IRegistCodeRequesuModel {
  /**
   * ライセンスコード
   */
  code: string;
}

function AxiosPost(
  url: string,
  params: IRegistCodeRequesuModel,
  token?: string
) {
  if (token) {
    return axios.post(url, JSON.stringify(params), {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    });
  } else {
    return axios.post(url, JSON.stringify(params), {
      headers: { "Content-Type": "application/json" },
    });
  }
}

interface IAxiosInternalParams extends ICallbackParams {
  promise: Promise<AxiosResponse>;
}

function AxiosInternal(params: IAxiosInternalParams) {
  params.promise
    .then((res) => {
      params.success(res.status);
    })
    .catch((err) => {
      const { id, status } = getErrorStatus(err);
      params.fail(id, status);
    });
}

export interface IRegistCodeParams
  extends IRegistCodeRequesuModel,
    ICallbackParams {
  /**
   * 認証オブジェクト
   */
  authService?: AuthService;
}

/**
 * ライセンスコードを登録します
 * @function registCode
 * @param {IRegistCodeParams} params - ライセンスコード登録パラメータ
 */
export function registCode(params: IRegistCodeParams): void {
  const { authService, code } = params;
  const req: IRegistCodeRequesuModel = {
    code: code,
  };
  const url = WebAPI.REGIST_CODE;
  if (authService) {
    authService.getToken({
      success: (token) => {
        AxiosInternal({
          promise: AxiosPost(url, req, token),
          success: params.success,
          fail: (id, status) => {
            if (status === 401) {
              registCodeRetry401(authService, url, req, params);
            } else {
              params.fail(id, status);
            }
          },
        });
      },
      fail: (err) => {
        const { id, status } = getErrorStatus(err);
        params.fail(id, status);
      },
    });
  } else {
    AxiosInternal({
      promise: AxiosPost(url, req),
      success: params.success,
      fail: params.fail,
    });
  }
}

/**
 * ライセンスコードを登録します
 * @function registCodeRetry401
 * @param {AuthService} authService - 認証オブジェクト
 * @param {string} url - リクエストURL
 * @param {IRegistCodeRequesuModel} req - リクエストパラメータ
 * @param {ICallbackParams} params - コールバックパラメータ
 */
export function registCodeRetry401(
  authService: AuthService,
  url: string,
  req: IRegistCodeRequesuModel,
  params: ICallbackParams
): void {
  authService.updateToken({
    success: (token) => {
      AxiosInternal({
        promise: AxiosPost(url, req, token),
        success: params.success,
        fail: params.fail,
      });
    },
    fail: (err) => {
      const { id, status } = getErrorStatus(err);
      params.fail(id, status);
    },
  });
}
